export const radioGroupModes = {
  vertical: 'vertical',
  horizontal: 'horizontal',
}
